import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { SystemGlobalsService } from '../../system-globals.service';

/**
 * Route guard that only lets master administrators through.
 *
 * Mirrors SubjectsRegistrarGuard: anybody else is sent back to the home page
 * instead of seeing a half-rendered master-admin screen.
 */
@Injectable({
	providedIn: 'root'
})
export class MasterAdminGuard implements CanActivate
{
	constructor(
		private _globals: SystemGlobalsService,
		private _router: Router
	) {}

	/**
	 * Allows navigation for master administrators, redirects everyone else to /home.
	 */
	canActivate(): boolean | UrlTree
	{
		if (this._globals.isMasterAdmin === true)
		{
			return true;
		}

		return this._router.parseUrl('/home');
	}
}
